export default "/images/burcher.svg?527c6914436c466c05a53af38ec9b720";